import { Component } from '@angular/core';
import { DialogConfig } from '@ddt-web/dialog';

@Component({
	selector: 'ac-simple-dcr-content-dialog',
	templateUrl: './simple-dcr-content-dialog.component.html',
	styleUrls: ['./simple-dcr-content-dialog.component.scss']
})
export class SimpleDcrContentDialogComponent {

	public titleDCRKey: string | string[] = '';
	public contentDCRKey: string | string[] = '';
	public disclaimerDCRKey: string = '';

	constructor(public config: DialogConfig) {
		this.titleDCRKey = config?.data?.titleDCRKey;
		this.contentDCRKey = config?.data?.contentDCRKey ?? 'No content found';
		this.disclaimerDCRKey = config?.data?.disclaimerDCRKey ?? '';
	}

}
